import PlatformFormComponent from './PlatformForm.component'

export default PlatformFormComponent